import { useQuery } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { ICurSchoolMyKDTApply, ICurSchoolMyKDTApplyResponse } from '../types'
import { ConvertType, convertCaseList } from '@/shared/utils/convertString'
import axiosInstance from '@/shared/utils/axios'

const fetchCurSchoolMyKDTApply = async (courseId: string, applyType: string | null) => {
  let resp: AxiosResponse<ICurSchoolMyKDTApplyResponse> | undefined
  if (applyType) {
    if (applyType !== 'end') {
      resp = await axiosInstance.get<ICurSchoolMyKDTApplyResponse>(
        `${process.env.NEXT_PUBLIC_API_ENDPOINT}/my/course/v1/courses/${courseId}/kdt-applies?apply_type=${applyType}`,
      )
    }
  }

  return convertCaseList(resp?.data, ConvertType.CAMEL) as ICurSchoolMyKDTApply
}

export const useCurSchoolMyKDTApply = (courseId: string, applyType: string | null) => {
  return useQuery<ICurSchoolMyKDTApply>({
    queryKey: ['curSchoolMyKDTApply', courseId, applyType],
    queryFn: () => fetchCurSchoolMyKDTApply(courseId, applyType),
    retry: false,
  })
}
